import { TOGGLE_PDP_MODAL } from './actions';

export const togglePdpModal = (product) => {
  return (dispatch) => {
    dispatch({
      product,
      type: TOGGLE_PDP_MODAL,
    });
  };
};
